import { render, staticRenderFns } from "./SupplementalMaterials.vue?vue&type=template&id=cfb0dfe6&scoped=true"
import script from "./SupplementalMaterials.vue?vue&type=script&lang=js"
export * from "./SupplementalMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb0dfe6",
  null
  
)

export default component.exports